import debug from 'debug';
import Modal from 'Minetilbud/Shared/Components/overlay/modal'
import userSvg from 'Minetilbud/Shared/Icons/tactile/icon_user.svg';
import Behaviour from '../static/behaviour';

const log = debug('FrontPageFavoritesOverlay:Render:FavoriteInfo');

class FavoriteInfo extends Modal {
	constructor(instanceId) {
		super(instanceId);

		this.loginLinkEvent = this.loginLinkHandler.bind(this);
	}

	eventListerners() {
		super.eventListerners();

		this.dom.loginLink.addEventListener('click', this.loginLinkEvent, false);
	}

	async get() {
		const template = document.querySelector('#FrontPageFavoritesOverlayTemplate');

		const container = this.create({
			baseClass: 'favorite-info',
			view: template.innerHTML
		});

		return container;
	}

	initialize() {
		this.dom.icon.insertAdjacentHTML('afterbegin', userSvg);
	}

	/**
	 * @param {Event} event
	 */
	loginLinkHandler(event) {
		event.preventDefault();
		Behaviour.dispatchEvent(Behaviour.eventKeys.infoToForm, {
			instanceId: this.instanceId
		});
	}

}

export default FavoriteInfo;
